export const templates = [
  {
    id: 'wa_contacto_inicial',
    name: 'WA Contacto Inicial',
    content:
      'Hola [Nombre], soy [Tu nombre] de Growthly. Montamos webs y menús digitales para restaurantes en [Ciudad]. ¿Le envío dos capturas de ejemplo y una propuesta breve?',
    channel: 'WhatsApp',
  },
  {
    id: 'wa_tras_aceptacion',
    name: 'WA Tras Aceptación',
    content:
      'Gracias, [Nombre]. Le adjunto 2 capturas... ¿Le va bien que le muestre una propuesta visual adaptada y rápida de 1 página?',
    channel: 'WhatsApp',
  },
  {
    id: 'wa_recordatorio_48h',
    name: 'Recordatorio 48h',
    content:
      'Hola [Nombre], solo un recordatorio amable: le envié una propuesta visual hace 48h...',
    channel: 'WhatsApp',
  },
  {
    id: 'wa_ultimo_empujon',
    name: 'Último Empujón',
    content: 'Esta semana estamos cerrando huecos para demos cortas...',
    channel: 'WhatsApp',
  },
  {
    id: 'tel_apertura',
    name: 'Apertura telefónica 30-45s',
    content:
      'Hola, ¿hablo con [Nombre]? Soy [Tu Nombre] de Growthly. Ayudamos a restaurantes en [Barrio] a atraer más reservas con una web y menú digital listos en pocos días. ¿Tiene 60 segundos...?',
    channel: 'Teléfono',
  },
  {
    id: 'email_propuesta',
    name: 'Email Propuesta 1p',
    content:
      'Asunto: Propuesta Visual para [Nombre_Negocio]\n\nHola [Nombre],\n\nAdjunto la propuesta de 1 página que comentamos. Quedo a la espera de sus comentarios.\n\nSaludos,\n[Tu nombre]',
    channel: 'Email',
  },
]
